export default __webpack_public_path__ + "static/media/whitePeople7.8571afe0.svg";